import {
  PrimaryDataContainer,
  TDCTOContainer,
  TDCTOPrimaryHeading,
  TDCTOPrimarySectionDescriptionItem,
  TDCTOPrimarySectionHeadingItem,
  TDCTOSectionsContainer,
} from './TDCTypeOneStyles'

export default function TDCTypeOne({
  heading,
  primaryData,
  secondaryData,
  SecondaryDataComponent,
  SecondarySideActionButtonComponent,
  buttonsOnClick,
}) {
  return (
    <TDCTOContainer>
      {heading && <TDCTOPrimaryHeading>{heading}</TDCTOPrimaryHeading>}
      <TDCTOSectionsContainer>
        <PrimaryDataContainer>
          {primaryData?.map((item, index) => {
            return (
              <div key={index} style={{ marginBottom: '16px' }}>
                <TDCTOPrimarySectionHeadingItem propColor={item?.headingColor}>
                  {item?.heading}
                </TDCTOPrimarySectionHeadingItem>
                {item?.descriptionComponent && item?.descriptionComponent}
                <TDCTOPrimarySectionDescriptionItem propColor={item?.descriptionColor}>
                  {item?.description}
                </TDCTOPrimarySectionDescriptionItem>
              </div>
            )
          })}
        </PrimaryDataContainer>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {secondaryData?.map((item, index) => {
            return (
              <SecondaryDataComponent
                key={index}
                icon={item?.icon}
                primaryText={item?.primaryText}
                secondaryText={item?.secondaryText}
                index={index}
              />
            )
          })}
          <div
            style={{
              marginTop: '20px',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <SecondarySideActionButtonComponent buttonsOnClick={buttonsOnClick} />
          </div>
        </div>
      </TDCTOSectionsContainer>
    </TDCTOContainer>
  )
}
